module.exports = __webpack_public_path__ + "img/accessBy_MTG_Logo.e1e33053.png";